export default __webpack_public_path__ + "static/media/Grupo Mov.6c110e4f.png";